<template>
  <div class="honor-container">
    <top-nav :shrinked="true"/>
    <img class="banner page-banner-hei" src="@/assets/honor/banner.jpg" alt="">
    <div class="site-text__content honor-base">
      <h3 class="text-blue site-text__content_h3">企业荣誉</h3>
      <div class="site-text__content_desc site-text__content_desc_align_left">
        <p>荣誉之光，照亮前行之路。每一次的荣耀，都是对企业不懈努力的肯定，激励我们继续追求卓越。嘉宏始终坚持长期主义，持续引领着城市高品质生活方式，为风华人生，创造更多标杆作品</p>
      </div>
    </div>
    <div class="site-content">
      <div class="site-container">
        <div class="site-navbar">
          <div class="slider-nav navbar-content">
<!--            <div v-for="(item,index) in sliderLists" :key="index">-->
<!--              <div class="slider-nav-item" :class="{'nav-active':navIndex===index}">-->
<!--                <div class="slider-nav-circle">-->
<!--                  <div class="slider-circle">-->
<!--                    <span></span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="slider-nav-text text-blue">{{item.title}}</div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div class="site-navbar-page">
            <div class="navbar-prev" :class="{'navbar-disabled':sliderIndex===0}" @click="prevClick"></div>
            <div class="navbar-next" :class="{'navbar-disabled':sliderIndex===sliderLists.length-1}" @click="nextClick"></div>
          </div>
        </div>
        <div class="slider-site honor-text">
<!--          <div v-for="(item,index) in sliderLists" :key="index">-->
<!--            <div class="honor-text-item">-->
<!--              <div class="honor-text-item-left">-->
<!--                <div class="left-ecli"></div>-->
<!--              </div>-->
<!--              <div class="honor-text-item-right">-->
<!--                <h2 class="text-blue">{{item.title}}</h2>-->
<!--                <div class="honor-label letter-base line-break">-->
<!--                  <p v-for="(item1,index1) in item.detailEntities" :key="index1">-->
<!--                    · {{item1.title}}-->
<!--                  </p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import 'slick-carousel/slick/slick.css';
  import 'slick-carousel/slick/slick-theme.css';
  import $ from 'jquery';
  import 'slick-carousel';
import topNav from '@/components/base/top-nav'
  import {fetchList} from '@/api/honor.js'
  import {formatTime} from '@/utils';
var that = null
export default {
  name: "honor",
  components:{
    topNav
  },
  data() {
    return {
      navIndex: 0,
      sliderIndex: 0,
      sliderLists:[]
    }
  },
  mounted() {
    that = this
    this.fetchData()
  },
  methods: {
      /**
       * 监听屏幕变化
       */
      handleResize(){
          $('.slider-nav').slick('resize');
      },
    fetchData(){
      fetchList().then(res=>{
        this.sliderLists = res.data
        let nav_slides = ''
        let site_slides = ''
        res.data.forEach((item,index)=>{
          nav_slides += '<div>\n'
          if(this.navIndex === index){
            nav_slides +=' <div class="slider-nav-item nav-active">\n'
          }else{
            nav_slides +=' <div class="slider-nav-item">\n'
          }
          nav_slides +='                <div class="slider-nav-circle">\n' +
                  '                  <div class="slider-circle">\n' +
                  '                    <span></span>\n' +
                  '                  </div>\n' +
                  '                </div>\n' +
                  '                <div class="slider-nav-text text-blue">'+ item.title + '</div>\n' +
                  '              </div>\n' +
                  '            </div>'


          // 构建轮播的HTML结构
          site_slides += '<div>\n' +
                  '<div class="honor-text-item">\n' +
                  '              <div class="honor-text-item-left">\n' +
                  '                <div class="left-ecli"></div>\n' +
                  '              </div>\n' +
                  '              <div class="honor-text-item-right">\n' +
                  '                <h2 class="text-blue">' + item.title + '</h2>\n' +
                  '                <div class="honor-label letter-base line-break">\n';
          item.detailEntities.forEach((item1, index1)=> {
            site_slides += '<p>· ' + item1.title +  '</p>\n'
          })
          site_slides +=     '  </div>\n' +
                  '              </div>\n' +
                  '            </div>\n' +
                  '</div>'
        })

          $('.slider-nav').html(nav_slides);
          // 将内容插入到轮播中
          $('.slider-site').html(site_slides);
          this.initSliders()
      })
    },
    updateSliders(){
        var navSlides = $('.slider-nav .slick-slide')
        navSlides.each(function(index, element) {
            if(that.sliderIndex === index) {
                $(element).find('.slider-nav-item').addClass('nav-active')
            } else{
                $(element).find('.slider-nav-item').removeClass('nav-active')
            }
        })
        $('.slider-nav').slick('setPosition');
        $('.slider-nav').slick('resize');
    },
    initSliders(){
      $('.slider-nav').slick({
        infinite: false,
        arrows:false,
        slidesToShow: 8,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 6
            }
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 4
            }
          }
        ]
      });
      $('.slider-nav').slick('setPosition');

      $('.slider-site').slick({
        dots: false,
        infinite: false,
        speed: 500,
        fade: true,
        arrows:true,
        draggable:false,
        slidesToShow: 1,
        adaptiveHeight: true,
        cssEase: 'linear',
        responsive: [
          {
              breakpoint: 768,
              settings: {
                  arrows: false,
                  draggable:true,
              }
          }
        ],
        prevArrow: "<button type='button' class='slick-prev slick-arrow'><img class='prev-img' src=" + require('@/assets/honor/left_arrow.png') + "></button>",
        nextArrow: "<button type='button' class='slick-next slick-arrow'><img class='prev-img' src=" + require('@/assets/honor/right_arrow.png') + "></button>",
      });
      $('.slider-site').slick('setPosition');
      $('.slider-site').on('afterChange', function pauseSlideShow(event, slick, currentSlide){
        that.sliderIndex = currentSlide
        $('.slider-nav').slick('slickGoTo', currentSlide);
        that.updateSliders()

      });
    },
    slickGoTo(index){
      $('.slider-nav').slick('slickGoTo', index);
      $('.slider-site').slick('slickGoTo', index);
    },
    prevClick(){
      if(this.sliderIndex > 0){
        this.sliderIndex --
        this.updateSliders()
        this.slickGoTo(that.sliderIndex)
      }
    },
    nextClick(){
      if(this.sliderIndex < this.sliderLists.length-1){
          that.sliderIndex ++
          this.updateSliders()
          this.slickGoTo(that.sliderIndex)
      }
    }
  }
}
</script>

<style>
  @import "../../styles/honor.css";
</style>
